import { patientConstants as constants } from '../_constants/patient.constants';
import { patientService as service } from '../_services/patient.service';
import { alertActions } from './alert.actions';

export const patientActions = {
  retrieveMessages,
  retrievePatientAxSLinks,
  retrieveById
};

function retrieveMessages() {
  return (dispatch, getState) => {
    const patient = getState().patient.current;

    dispatch(request());

    service.retrieveMessages(patient.id)
      .then((messages) => {
        dispatch(success(messages.data));
      })
      .catch(() => {
        dispatch(failure());
      });
  }

  function request() { return { type: constants.PATIENT_MSGS_REQUEST } }
  function success(messages) { return { type: constants.PATIENT_MSGS_SUCCESS, messages } }
  function failure() { return { type: constants.PATIENT_MSGS_FAILURE } }
}

function retrievePatientAxSLinks(id) {
  return dispatch => {
    dispatch(request());

    service.retrievePatientAxSLinks(id)
      .then((patient) => {
        dispatch(success(patient));
      })
      .catch(() => {
        dispatch(failure());

        dispatch(alertActions.error("Could not retrieve the patient at this time. Please try again."));
      });
  }

  function request() { return { type: constants.PATIENT_RETRIEVE_REQUEST } }
  function success(patient) { return { type: constants.PATIENT_RETRIEVE_SUCCESS, patient } }
  function failure() { return { type: constants.PATIENT_RETRIEVE_FAILURE } }
}

function retrieveById(id) {
  return dispatch => {
    dispatch(request());

    service.retrievePatient(id)
      .then((patient) => {
        dispatch(success(patient));
      })
      .catch(() => {
        dispatch(failure());

        dispatch(alertActions.error("Could not retrieve the patient at this time. Please try again."));
      });
  }

  function request() { return { type: constants.PATIENT_RETRIEVE_REQUEST } }
  function success(patient) { return { type: constants.PATIENT_RETRIEVE_SUCCESS, patient } }
  function failure() { return { type: constants.PATIENT_RETRIEVE_FAILURE } }
}